/**
 * Route table, composed from per-feature groups (architecture review item 10).
 *
 * Order is preserved from the original monolithic `routes` array. Note that
 * vue-router 4 ranks routes by path specificity, so cross-group ordering does
 * not affect matching; order-sensitive pairs (e.g. the dataset visualization
 * routes, and the catch-all) are kept within their own group file.
 */
import account from './account';
import admin from './admin';
import apiDocs from './apiDocs';
import apiStore from './apiStore';
import builder from './builder';
import changelog from './changelog';
import content from './content';
import core from './core';
import datasets from './datasets';
import myEnvironment from './myEnvironment';
import onboarding from './onboarding';
import publicPages from './public';
import tools from './tools';

export default [
  ...core,
  ...myEnvironment,
  ...builder,
  ...tools,
  ...publicPages,
  ...apiDocs,
  ...apiStore,
  ...content,
  ...changelog,
  ...account,
  ...admin,
  ...onboarding,
  ...datasets,
];
